import { apiFetch } from "./client";

export async function fetchBookings({ from, to, resource_id = "birdie_bus_1" }) {
  const params = new URLSearchParams({
    from,
    to,
    resource_id,
  });
  return apiFetch(`/api/bookings?${params.toString()}`);
}

export async function createBooking(payload) {
  return apiFetch("/api/bookings", {
    method: "POST",
    body: payload, // ✅ OBJECT, not stringified
  });
}

export async function updateBookingStatus(id, status) {
  return apiFetch(`/api/bookings/${id}`, {
    method: "PATCH",
    body: { status }, // ✅ OBJECT, not stringified
  });
}

export async function sendQuote(bookingId, quotedPriceCents) {
  return apiFetch(`/api/bookings/${bookingId}/quote`, {
    method: "POST",
    body: { quoted_price_cents: quotedPriceCents },
  });
}

export async function updateBookingDetails(bookingId, details) {
  return apiFetch(`/api/bookings/${bookingId}/details`, {
    method: "PUT",
    body: details,
  });
}

export async function deleteBooking(bookingId) {
  return apiFetch(`/api/bookings/${bookingId}`, {
    method: "DELETE",
  });
}